import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Paper } from '@mui/material';
import axios from 'axios';

const IntegrationDetail = () => {
  const { integrationName } = useParams();
  const [details, setDetails] = useState([]);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await axios.get(`/snowflake/integrations/${integrationName}`);
        setDetails(response.data);
      } catch (error) {
        console.error('Error fetching integration details:', error);
      }
    };

    fetchDetails();
  }, [integrationName]);

  const groupDetails = (details) => {
  const grouped = {};

  details.forEach(detail => {
    const property = detail.property;
    console.log("Property: ", detail)
    if (!grouped[property]) {
      grouped[property] = {
        type: '',
        value: '',
        default: '',
      };
    }
    grouped[property].type = detail.property_type
    grouped[property].value = detail.property_value
    grouped[property].default = detail.property_default


  });

  return grouped;
};

  const groupedDetails = groupDetails(details);

  return (
    <Box m="20px">
      <Typography variant="h4">Integration: {integrationName}</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 2 }}>
        {Object.entries(groupedDetails).map(([propertyName, propertyDetails], index) => (
          <Paper key={index} sx={{ p: 2, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ wordBreak: 'break-word' }}>{propertyName}</Typography>
            <Typography sx={{ wordBreak: 'break-word' }}>Type: {propertyDetails.type}</Typography>
            <Typography sx={{ wordBreak: 'break-word' }}>Value: {propertyDetails.value}</Typography>
            <Typography sx={{ wordBreak: 'break-word' }}>Default: {propertyDetails.default}</Typography>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default IntegrationDetail;